export enum TipoDeDesconto {
  PERCENTUAL = 'PERCENTUAL',
  VALOR = 'VALOR',
  SEM_DESCONTO = 'SEM_DESCONTO',
}
